export class AccessTokenResponse {
    accessToken: string;
    expireDate: number;

    constructor(data: { accessToken: string; expireDate: number }) {
        this.accessToken = data.accessToken;
        this.expireDate = data.expireDate;
    }
}